import React, { useState, useEffect, useMemo } from 'react';
import authService from './api-authorization/AuthorizeService'
import axios from 'axios'
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import Switch from '@mui/material/Switch';
import TextField from '@mui/material/TextField';
import LoadingButton from '@mui/lab/LoadingButton';
import Grid from '@mui/material/Grid';
import MUIDataTable, { ExpandButton } from "mui-datatables";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import DeleteUser from '@mui/icons-material/Delete'
import LockUser from '@mui/icons-material/Lock'
import UnLockUser from '@mui/icons-material/LockOpen'
import MarkEmailConfirmed from '@mui/icons-material/MarkEmailRead'
import EditUser from '@mui/icons-material/ModeEdit'
import Select from '@mui/icons-material/HowToReg'
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { ConfirmProvider } from "material-ui-confirm";
import { useConfirm } from "material-ui-confirm";
import { Link } from "react-router-dom";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import ContentCopy from '@mui/icons-material/ContentCopy';

const muiCache = createCache({
    key: 'mui-datatables',
    prepend: true,
});

export default function SelectUser() {
    const [token, setToken] = useState();
    const [searchString, setSearchString] = useState("");
    const [selectedUser, setSelectedUser] = useState();
    const [status, setStatus] = useState();
    const [appData, setAppData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [authenticated, setAuthenticated] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [userRole, setUserRole] = useState("");
    const confirm = useConfirm();
    const [showSupportersOnly, setShowSupportersOnly] = useState(true);
    const [passwordDialogOpen, setPasswordDialogOpen] = useState(false);
    const [passwordConfirmDialogOpen, setPasswordConfirmDialogOpen] = useState(false);
    const [selectedUserForPassword, setSelectedUserForPassword] = useState(null);
    const [newPassword, setNewPassword] = useState('');
    const [generatedPassword, setGeneratedPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [sendingEmail, setSendingEmail] = useState(false);

    const handleDelete = (user, popupState, confirm) => {
        confirm({ description: `This will permanently delete ${user.name}.` })
            .then(() => console.log('Deleted ${item}'))
            .catch(() => console.log("Deletion cancelled."));
    };

    const generateRandomString = (length) => {
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%';
        let result = '';
        for (let i = 0; i < length; i++) {
            result += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return result;
    };

    const handleCopyPassword = () => {
        navigator.clipboard.writeText(generatedPassword);
        alert('Password copied to clipboard!');
    };

    useEffect(async () => {
        setToken(await authService.getAccessToken());
        setAuthenticated(await authService.isAuthenticated());
        var user = await authService.getUser();
        if (user != null) {
            var role = user.role;
            setUserRole(role);
            if (role.includes("Administrators")) {
                await setIsAdmin(true);
            }

        }
    }, []);

    const isAdminUser = () => {
        if (isAdmin) return true;
        else return false;
    };

    const columns =
        [
            {
                name: "id",
                label: "ID",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowUser = appData[originalIndex];
                        return (
                            <Tooltip title={isAdminUser() ? "User Name : " + rowUser.userName : ""}>
                                <div > {value}</div>
                            </Tooltip>
                        );
                    }
                }
            },
            {
                name: "createdOn",
                label: "Registrated",
                options: {
                    filter: false,
                    sort: true,
                    display: isAdminUser(),
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowUser = appData[originalIndex];
                        return (
                            <Tooltip title={isAdminUser() ? "Last Login : " + (new Date(rowUser.lastLogIn + "Z")).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', }) : ""}>
                                <div > {(new Date(value + "Z")).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' })}</div>
                            </Tooltip>
                        );
                    }
                }
            },
            {
                name: "lastLogIn",
                label: "Last Login",
                options: {
                    filter: false,
                    sort: true,
                    display: false,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <div style={{ textAlign: "left" }}> {(new Date(value + "Z")).toLocaleString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })}</div>
                        );
                    }
                }
            },
            {
                name: "createdFromIP",
                label: "Creation IP",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    display: false,
                    viewColumns: true,
                }
            },
            {
                name: "lastLogInFromIP",
                label: "Last Login IP",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    display: false,
                    viewColumns: true,
                }
            },
            {
                name: "userFideId",
                label: "FIDE",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <div style={{ textAlign: "left" }}> {value != -1 ? (<a href={'https://ratings.fide.com/profile/' + value} target='_blank' rel='noreferrer'>{value}</a>) : (value)}</div>
                        );
                    }
                }
            },
            {
                name: "userUscfId",
                label: "USCF",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        return (
                            <div style={{ textAlign: "left" }}> {value != -1 ? (<a href={'http://www.uschess.org/msa/MbrDtlMain.php?' + value} target='_blank' rel='noreferrer'>{value}</a>) : (value)}</div>
                        );
                    }
                }
            },
            {
                name: "name",
                label: "Name",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowUser = appData[originalIndex];
                        let idType = rowUser.userFideId > 0 ? "FIDE" : "USCF";
                        let id = rowUser.userFideId > 0 ? rowUser.userFideId : rowUser.userUscfId;

                        return (
                            <Tooltip title={isAdminUser() ? "Phone : " + rowUser.phoneNumber : ""}>
                                <div style={{ textAlign: "left" }}> {id != -1 ? (<Link target="_blank" to={'/players/details?idtype=' + idType + '&id=' + id} className="button">{value}</Link>) : (value)}</div>
                            </Tooltip>
                        );
                    }
                }
            },
            {
                name: "membershipLevel",
                label: "Level",
                options: {
                    filter: false,
                    sort: true,
                    display: isAdminUser(),
                    sortThirdClickReset: true,
                    viewColumns: true,
                }
            },
            {
                name: "emailConfirmed",
                label: "Confirmed",
                options: {
                    filter: false,
                    sort: true,
                    display: isAdminUser(),
                    sortThirdClickReset: true,
                    viewColumns: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowUser = appData[originalIndex];
                        return (
                            <Tooltip title={isAdminUser() ? "Email : " + rowUser.email : ""}>
                                <Switch checked={value} />
                            </Tooltip>
                        );
                    }
                }
            },
            {
                name: "isSupporter",
                label: "Supporter",
                options: {
                    filter: false,
                    sort: true,
                    display: isAdminUser(),
                    sortThirdClickReset: true,
                    viewColumns: true,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowUser = appData[originalIndex];
                        return (
                            <Tooltip title={isAdminUser() ? "Supporter Exp : " + rowUser.supporterStatusExpDateUtc : ""}>
                                <Switch checked={value} />
                            </Tooltip>
                        );
                    }
                }
            },
            {
                name: "email",
                label: "Email",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    display: false,
                    viewColumns: true,
                }
            },
            {
                name: "phoneNumber",
                label: "Phone",
                options: {
                    filter: false,
                    sort: true,
                    sortThirdClickReset: true,
                    display: false,
                    viewColumns: true,
                }
            },
            {
                name: "",
                label: "Actions",
                options: {
                    filter: false,
                    filterType: 'multiselect',
                    sort: false,
                    display: true,
                    sortThirdClickReset: false,
                    customBodyRender: (value, tableMeta, updateValue) => {
                        let originalIndex = tableMeta.currentTableData[tableMeta.rowIndex].index;
                        let rowUser = appData[originalIndex];
                        const isBuiltInAdmin = rowUser.userName?.toLowerCase() === 'admin' || rowUser.name?.toLowerCase() === 'admin';
                        
                        return (
                            <div style={{ textAlign: "left" }}>
                                {isAdmin &&
                                    <PopupState variant="popover" popupId="demo-popup-menu">
                                        {(popupState) => (
                                            <React.Fragment>
                                                <Button variant="contained" {...bindTrigger(popupState)}>
                                                    Actions
                                                </Button>
                                                <Menu {...bindMenu(popupState)}>
                                                    {!rowUser.emailConfirmed &&
                                                        <MenuItem onClick={async () => { await confirmEmail(rowUser, popupState); }}>Confirm Email</MenuItem>
                                                    }
                                                    {!rowUser.isSupporter &&
                                                        <MenuItem onClick={async () => { await addOneYearSupporterMembership(rowUser, popupState); }}>Add 1 Year Supporter Membership</MenuItem>
                                                    }
                                                    <MenuItem onClick={async () => { await cancelSupporterMembership(rowUser, popupState); }}>Cancel Supporter Membership</MenuItem>
                                                    {!isBuiltInAdmin && (
                                                        <MenuItem onClick={popupState.close}>Lock Account</MenuItem>
                                                    )}
                                                    {!isBuiltInAdmin && (
                                                        <MenuItem onClick={popupState.close}>Unlock Account</MenuItem>
                                                    )}
                                                    <MenuItem onClick={async () => { await setPasswordForUser(rowUser, popupState); }}>Set Password</MenuItem>
                                                    <MenuItem onClick={async () => { await makeUserAdmin(rowUser, popupState); }}>Make Admin</MenuItem>
                                                    {!isBuiltInAdmin && (
                                                        <MenuItem onClick={async () => { await revokeAdminRole(rowUser, popupState); }}>Revoke Admin</MenuItem>
                                                    )}
                                                    <MenuItem onClick={popupState.close}>Edit</MenuItem>
                                                    {!isBuiltInAdmin && (
                                                        <MenuItem onClick={async () => {
                                                            await deleteUser(rowUser, popupState)
                                                        }
                                                        }>Delete</MenuItem>
                                                    )}
                                                </Menu>
                                            </React.Fragment>
                                        )}
                                    </PopupState>
                                }
                                {!isAdmin &&
                                    <div>
                                        <Button variant="contained" onClick={async () => await setSelectedUser(rowUser)}>
                                            Select
                                        </Button>
                                    </div>
                                }
                            </div>
                        );
                    }


                }
            },
        ];

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'simple',
        expandableRows: isAdminUser(),
        selectableRows: 'none',
        expandableRowsOnClick: false,
        expandableRowsHeader: false,
        isRowExpandable: (dataIndex, expandedRows) => {
            if (isAdmin)
                return true;
            return false;
        },
        rowsExpanded: [],
        renderExpandableRow: (rowData, rowMeta) => {
            const detail = appData[rowMeta.dataIndex];
            const colSpan = rowData.length + 1;
            console.log(detail);
            return (
                <div><pre>{JSON.stringify(detail, null, 2)}</pre></div>
            );
        },
        onRowExpansionChange: (curExpanded, allExpanded, rowsExpanded) =>
            console.log(curExpanded, allExpanded, rowsExpanded),

    };

    const theme = createTheme({
        overrides: {
            MUIDataTableSelectCell: {
                expandDisabled: {
                    visibility: 'hidden',
                },
            },
        },
    });

    const components = {
        ExpandButton: function (props) {
            return <ExpandButton {...props} />;
        },
    };

    const getAppData = async (e, playerName) => {
        e.preventDefault();
        setToken(await authService.getAccessToken());
        var headers = {
            headers: { 'Authorization': `Bearer ${token}` }
        }
        axios.get('/api/NACHUsers/SearchUser?showSupportersOnly=' + showSupportersOnly + '&searchString=' + playerName, headers).then((response) => {
            setAppData(response.data);
            setStatus("");
            setLoading(false);
        }).catch((error) => {
            setLoading(false);
            setStatus("Error - Please check log for details.");
            console.log(JSON.stringify(error));
        });
    };

    const makeUserAdmin = async (nachUser, popupState) => {
        popupState.close();

        confirm({ 
            description: `This will grant Administrator role to ${nachUser.name}. This is a powerful permission.`,
            confirmationText: 'Make Admin'
        })
            .then(async () => {
                const myToken = await authService.getAccessToken();
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + myToken,
                    }
                };
                const res = await fetch(`/api/NACHUsers/MakeAdmin/${nachUser.id}`, requestOptions);
                if (res.ok) {
                    const message = await res.text();
                    alert(message);
                    // Refresh the user list to show updated data
                    await getAppData({ preventDefault: () => {} }, searchString);
                } else {
                    const error = await res.text();
                    alert(`Error: ${error}`);
                }
            })
            .catch(() => console.log("Make admin cancelled."));
    };

    const revokeAdminRole = async (nachUser, popupState) => {
        popupState.close();

        // Prevent revoking admin from the built-in admin account
        if (nachUser.userName?.toLowerCase() === 'admin' || nachUser.name?.toLowerCase() === 'admin') {
            alert('Cannot revoke administrator role from the built-in admin account.');
            return;
        }

        confirm({ 
            description: `This will revoke Administrator role from ${nachUser.name}.`,
            confirmationText: 'Revoke Admin'
        })
            .then(async () => {
                const myToken = await authService.getAccessToken();
                const requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + myToken,
                    }
                };
                const res = await fetch(`/api/NACHUsers/RevokeAdmin/${nachUser.id}`, requestOptions);
                if (res.ok) {
                    const message = await res.text();
                    alert(message);
                    // Refresh the user list to show updated data
                    await getAppData({ preventDefault: () => {} }, searchString);
                } else {
                    const error = await res.text();
                    alert(`Error: ${error}`);
                }
            })
            .catch(() => console.log("Revoke admin cancelled."));
    };

    const deleteUser = async (nachUser, popupState) => {
        popupState.close();

        confirm({ description: `This will permanently delete user account for ${nachUser.name}.`, confirmationText: 'Delete' })
            .then(async () => {
                const myToken = await authService.getAccessToken();
                const requestOptions = {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + myToken,
                    }
                };
                const res = await fetch('/api/NACHUsers/' + nachUser.id, requestOptions);
                if (res.ok) {
                    let updatedAppData = appData.filter(u => u.id !== nachUser.id);
                    setAppData(updatedAppData);
                    alert('User deleted successfully');
                } else {
                    const error = await res.text();
                    alert(`Error deleting user: ${error}`);
                }
            })
            .catch(() => console.log("Deletion cancelled."));
    }

    const confirmEmail = async (nachUser, popupState) => {
        popupState.close();
        const myToken = await authService.getAccessToken();
        const requestOptions = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + myToken,
            },
            body: JSON.stringify(nachUser)
        };
        const res = await fetch('/api/NACHUsers/ConfirmEmail/' + nachUser.id, requestOptions);
        if (res.ok) {
            setAppData(prevState => {
                const newState = prevState.map(obj => {
                    if (obj.id === nachUser.id) {
                        return { ...obj, emailConfirmed: 'true' };
                    }
                    return obj;
                });
                return newState;
            });
        }
    }

    const addOneYearSupporterMembership = async (nachUser, popupState) => {
        popupState.close();
        const myToken = await authService.getAccessToken();
        const requestOptions = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + myToken,
            },
            body: JSON.stringify(nachUser)
        };
        const res = await fetch('/api/NACHUsers/AddOneYearSupporterMembership/' + nachUser.id, requestOptions);
        if (res.ok) {
            setAppData(prevState => {
                const newState = prevState.map(obj => {
                    if (obj.id === nachUser.id) {
                        return { ...obj, isSupporter: 'true' };
                    }
                    return obj;
                });
                return newState;
            });
        }
    }

    const cancelSupporterMembership = async (nachUser, popupState) => {
        popupState.close();
        const myToken = await authService.getAccessToken();
        const requestOptions = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + myToken,
            },
            body: JSON.stringify(nachUser)
        };
        const res = await fetch('/api/NACHUsers/cancelSupporterMembership/' + nachUser.id, requestOptions);
        if (res.ok) {
            setAppData(prevState => {
                const newState = prevState.map(obj => {
                    if (obj.id === nachUser.id) {
                        return { ...obj, isSupporter: 'false' };
                    }
                    return obj;
                });
                return newState;
            });
        }
    }

    const setPasswordForUser = async (nachUser, popupState) => {
        popupState.close();

        // Generate default password with random 4-char suffix
        const randomSuffix = generateRandomString(4);
        const defaultPassword = `Che$$${nachUser.id}!${randomSuffix}`;
        setNewPassword(defaultPassword);
        setSelectedUserForPassword(nachUser);
        setPasswordDialogOpen(true);
    };

    const handlePasswordDialogClose = () => {
        setPasswordDialogOpen(false);
        setSelectedUserForPassword(null);
        setNewPassword('');
    };

    const handlePasswordConfirmDialogClose = () => {
        setPasswordConfirmDialogOpen(false);
        setGeneratedPassword('');
        setSelectedUserForPassword(null);
        setShowPassword(false);
    };

    const handlePasswordSubmit = async () => {
        if (!selectedUserForPassword || !newPassword) {
            return;
        }

        const myToken = await authService.getAccessToken();
        const requestOptions = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + myToken,
            },
            body: JSON.stringify({ newPassword: newPassword })
        };

        try {
            const res = await fetch(`/api/NACHUsers/AdminSetPassword/${selectedUserForPassword.id}`, requestOptions);
            if (res.ok) {
                const response = await res.json();

                // Store the generated password
                setGeneratedPassword(response.newPassword);
                
                // IMPORTANT: Don't call handlePasswordDialogClose() here as it clears selectedUserForPassword
                // Just close the dialog manually
                setPasswordDialogOpen(false);
                setNewPassword('');
                
                // Now open confirmation dialog - selectedUserForPassword still has the user data
                setPasswordConfirmDialogOpen(true);
            } else {
                const error = await res.text();
                alert(`Error: ${error}`);
            }
        } catch (error) {
            alert(`Error: ${error.message}`);
        }
    };

    const handleSendPasswordEmail = async () => {
        if (!selectedUserForPassword || !generatedPassword) {
            return;
        }

        setSendingEmail(true);

        const myToken = await authService.getAccessToken();
        const requestOptions = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + myToken,
            },
            body: JSON.stringify({ newPassword: generatedPassword })
        };

        try {
            const res = await fetch(`/api/NACHUsers/SendPasswordEmail/${selectedUserForPassword.id}`, requestOptions);
            if (res.ok) {
                const message = await res.text();
                alert(message);
                handlePasswordConfirmDialogClose();
            } else {
                const error = await res.text();
                alert(`Error: ${error}`);
            }
        } catch (error) {
            alert(`Error: ${error.message}`);
        } finally {
            setSendingEmail(false);
        }
    };

    return (
        <Box sx={{ pt: 2, pb: 2 }}>
            <Grid container direction="row" rowSpacing={1} columnSpacing={1} alignItems="flex-end">
                <Grid item xs={12} lg={isAdmin ? 5 : 12} >
                    <TextField
                        size="small"
                        fullWidth
                        id="outlined-number"
                        label={"Enter player's ID or Name (e.g. 1503014 | Magnus | Pragg | Carlsen, M | Mag Car)"}
                        InputLabelProps={{
                            shrink: true
                        }}
                        value={searchString}
                        onChange={(e) => setSearchString(e.target.value)}
                    />
                </Grid>
                {isAdmin &&
                    <Grid item xs={12} lg={2} >
                        <FormGroup>
                            <FormControlLabel control={<Checkbox defaultChecked checked={showSupportersOnly} onChange={e => { setShowSupportersOnly(e.target.checked); }} />} label="Supporters Only" />
                        </FormGroup>
                    </Grid>
                }
                <Grid item xs={12} lg={5}>
                    <Stack spacing={1} direction="row" justifyContent="end">
                        <LoadingButton
                            fullWidth
                            onClick={async (e) => {
                                if (searchString !== null && searchString.trim() !== '' && searchString.trim().length >= 3 && !searchString.startsWith("-1")) {
                                    await setLoading(true); await getAppData(e, searchString);
                                } else if (isAdmin) {
                                    await setLoading(true); await getAppData(e, searchString);
                                }
                            }}
                            loading={loading}
                            loadingIndicator="Loading..."
                            variant="contained">
                            Search NACH Users
                        </LoadingButton>
                    </Stack>
                </Grid>
                <Grid item xs={12}>
                    <div>
                        <label style={{ color: 'red' }}>{status}</label>
                    </div>
                </Grid>
                {selectedUser &&
                    <Grid item xs={12}>
                        <span>{JSON.stringify(selectedUser, null, 2)}</span>
                    </Grid>
                }
                {appData.length > 0 &&
                    <Grid item xs={12}>
                        <CacheProvider value={muiCache}>
                            <ThemeProvider theme={theme}>
                                <MUIDataTable
                                    title={<div>
                                        <Button variant="contained" color="secondary" onClick={async (e) => { e.preventDefault(); await setAppData([]); await setSelectedUser(); await setSearchString("") }}>{"Clear Results (" + appData.length + ")"}</Button>
                                    </div>}
                                    data={appData}
                                    columns={columns}
                                    options={options}
                                    components={components}
                                />
                            </ThemeProvider>
                        </CacheProvider>
                    </Grid>
                }
            </Grid>

            {/* Password Input Dialog */}
            <Dialog open={passwordDialogOpen} onClose={handlePasswordDialogClose}>
                <DialogTitle>Set Password for {selectedUserForPassword?.name}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Set a new password for this user. The account will be unlocked automatically.
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        label="New Password"
                        type="text"
                        fullWidth
                        variant="standard"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        helperText="Password includes random 4-character suffix for security"
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handlePasswordDialogClose}>Cancel</Button>
                    <Button onClick={handlePasswordSubmit} variant="contained" color="primary">
                        Set Password
                    </Button>
                </DialogActions>
            </Dialog>

            {/* Password Confirmation Dialog */}
            <Dialog
                open={passwordConfirmDialogOpen}
                onClose={handlePasswordConfirmDialogClose}
                maxWidth="sm"
                fullWidth
            >
                <DialogTitle>Password Set Successfully</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        The password has been set successfully for <strong>{selectedUserForPassword?.name}</strong>.
                    </DialogContentText>
                    <Box sx={{ mt: 2, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
                        <DialogContentText variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                            Generated Password:
                        </DialogContentText>
                        <TextField
                            fullWidth
                            variant="outlined"
                            value={generatedPassword}
                            InputProps={{
                                readOnly: true,
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            aria-label="copy password"
                                            onClick={handleCopyPassword}
                                            edge="end"
                                        >
                                            <ContentCopy />
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handlePasswordConfirmDialogClose}>Close</Button>
                    <Button
                        onClick={handleSendPasswordEmail}
                        color="primary"
                        variant="contained"
                        disabled={sendingEmail}
                    >
                        {sendingEmail ? "Sending..." : "Send Password via Email"}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box >
    );
}